import { Box, Container } from "@mui/material";
import NoteCard from "@/components/NoteCard";
import MainAppBar from "@/components/MainAppBar";
import CommentSkeleton from "@/fragments/CommentSkeleton";
import { useParams } from "react-router-dom";
import BottomTabs from "@/components/BottomTabs";
import SideTabs from "@/components/SideTabs";
import { useNotes } from "@/services/hooks";
import { SubscribedProvider } from "@/providers/Subscribed";
export default function Notes() {
  const { artistKey } = useParams();

  const { data: artistContent, isLoading } = useNotes(artistKey);

  return (
    <SubscribedProvider artistKey={artistKey}>
      <Container maxWidth="sm" disableGutters>
        <MainAppBar />

        {isLoading && <NoteCardSkeleton />}

        <Box
          sx={{
            px: 2,
            pb: 15,
          }}
        >
          <Box id="main-feed">
            <Box style={{ marginBottom: "100px" }}>
              {artistContent?.map((content, index) => (
                <Box key={index}>
                  <NoteCard content={content} />
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
        <BottomTabs />
        <SideTabs />
      </Container>
    </SubscribedProvider>
  );
}

function NoteCardSkeleton() {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 4, mt: 4 }}>
      <CommentSkeleton />
      <CommentSkeleton />
      <CommentSkeleton />
      <CommentSkeleton />
      <CommentSkeleton />
    </Box>
  );
}
